// extracted by mini-css-extract-plugin
export default {"closeBtn":"gYb_D"};